<template>
  <v-card
    class="ma-0"
    width="100%"
    style="height: auto"
    elevation="2"
  >
    <v-app-bar
      flat
      class="my-0 py-1 mb-2 px-4"
      dense
      height="30"
    >
      <v-toolbar-title>{{ $t($route.name) }}</v-toolbar-title>
      <v-spacer />
      <v-btn
        v-shortkey="['f5']"
        @shortkey="getItems"
        color="primary"
        outlined
        class="mt-2"
        small
        :loading="loading"
        @click="getItems"
      >
        {{ $t('getReport') }}
      </v-btn>
    </v-app-bar>
    <v-progress-linear
      :active="loading"
      :indeterminate="loading"
      absolute
      bottom
      style="top: -4px"
      color="primary"
    />
    <v-row>
      <v-col class="d-flex py-0">
        <v-col
          cols="12"
          md="3"
        >
          <v-select
            v-model="book"
            :label="$t('bookType')"
            :items="bookItems"
            height="32"
            dense
            outlined
            clearable
            hide-details
            item-value="value"
            item-text="text"
          />
        </v-col>
        <v-col
          cols="12"
          md="3"
        >
          <autocomplete
            v-model="fromFinancialYear"
            :title="$t('fromFinancialYear')"
            type="year"
            :value="fromFinancialYear"
          />
        </v-col>
        <v-col
          cols="12"
          md="3"
        >
          <autocomplete
            v-model="toFinancialYear"
            :title="$t('toFinancialYear')"
            type="year"
            :value="toFinancialYear"
          />
        </v-col>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="d-flex py-0">
        <v-col
          cols="12"
          md="3"
        >
          <autocomplete
            v-model="totalAccount"
            :title="$t('totalAccount')"
            type="total"
            :filter="true"
            :multiple="true"
          />
        </v-col>
        <v-col
          cols="12"
          md="3"
        >
          <template>
            <v-text-field
              id="fromId"
              v-model="fromDate"
              :label="$t('from') + ' ' + $t('date')"
              outlined
              dense
              clearable
            />

            <date-picker
              v-model="fromDate"
              element="fromId"
              :locale="$store.state.date_locale"
              :format="$store.state.date_format"
              auto-submit
              :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
              @close="setDate"
            />
          </template>
        </v-col>
        <v-col
          cols="12"
          md="3"
        >
          <template>
            <v-text-field
              id="toId"
              v-model="toDate"
              :label="$t('until') + ' ' + $t('date')"
              outlined
              dense
              clearable
            />

            <date-picker
              v-model="toDate"
              element="toId"
              :locale="$store.state.date_locale"
              :format="$store.state.date_format"
              :min="fromDate"
              auto-submit
              :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
              @close="setDate"
            />
          </template>
        </v-col>
      </v-col>
    </v-row>
    <v-row class="mx-0">
      <v-col
        class="pb-2 px-2"
        cols="12"
      >
        <print
          :data-prop="data"
          :report-prop="reportName"
          :resource-prop="reportName"
        />
      </v-col>
<!--      <v-col-->
<!--        class="pb-2 px-2"-->
<!--        cols="12"-->
<!--      >-->
<!--        <ag-grid-vue-->
<!--          style="width: 100%; height: 300px;font-family: IRANSans !important;"-->
<!--          class="ag-theme-alpine"-->
<!--          :column-defs="columnDefs"-->
<!--          :row-data="items"-->
<!--          :detail-row-auto-height="true"-->
<!--          :locale-text="localeText"-->
<!--          :enable-rtl="true"-->
<!--          @grid-ready="onGridReady"-->
<!--        />-->
<!--      </v-col>-->
    </v-row>
    <v-row />
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="deletDialog"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="deletDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img
            class="mx-auto"
            width="200"
            src="@/assets/stop.svg"
          />
        </v-col>
        <v-col
          class="mt-3 pr-7"
        >
          <p class="mx-auto font-weight-medium">
            {{ $t('are-you-sure-delete-this-case') }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                v-if="selected.length > 0"
                color="primary"
              >
                {{ $t('remove') }}
              </v-btn>
              <v-btn
                v-if="selected.length == 0"
                color="primary"
              >
                {{ $t('remove') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--    upload dialog-->
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : '')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
  import General from '../../../../Mixins/general'
  // import { AgGridVue } from 'ag-grid-vue'
  import AG_GRID_LOCALE_EN from './../../../../locales/fa.json'
  import print from './../../components/general/printViewer/printViewer'
  export default {
    name: 'AccountingBook',
    components: {
      print,
      // AgGridVue,
    },
    mixins: [General],
    props: [],
    data: () => ({
      selected: [],
      fromFinancialYear: null,
      toFinancialYear: null,
      year: null,
      book: 'total',
      totalAccount: null,
      bookItems: null,
      category: null,
      integratorType: null,
      rangeDate: null,
      registerar: null,
      attractionMethod: null,
      toDate: null,
      fromDate: null,
      printDialog: false,
      uploadDialog: false,
      accountDialog: false,
      deletDialog: false,
      filter: false,
      financialStatus: null,
      customerStatus: null,
      status: 'active',
      taskindex: 0,
      lead: null,
      refId: null,
      taskItem: null,
      model: null,
      from: 1,
      taskDialog: null,
      taskDialogList: null,
      showSelect: null,
      tag: null,
      temp: null,
      sellStatus: null,
      items: [],
      sortBy: [],
      data: null,
      dialog: null,
      timer: 0,
      totalItems: 0,
      snakbar: false,
      snakbarText: null,
      loading: false,
      options: {
        itemsPerPage: 5,
      },
      deleteItem: null,
      headers: null,
      personnel: null,
      search: null,
      renderTable: null,
      selectedHeaders: [],
      columnDefs: null,
      rowData: null,
      gridApi: null,
      localeText: null,
      reportName: null,
    }),
    computed: {
      isMobile () {
        return this.$vuetify.breakpoint.name === 'xs'
      },
      showHeaders () {
        var app = this
        return this.headers.filter(function (s) {
          return app.selectedHeaders.includes(s)
        })
      },
      // totals: function () {
      // var app = this
      // app.excelItems = []
      // const totals = this.items.reduce((acc, d, index) => {
      //   acc.amount += parseFloat((d.remain ? d.remain : 0))
      //   app.excelItems.push({
      //     row: +index + +1,
      //     // name: String(d.name),
      //     // category: (d.category ? d.category.name : ''),
      //     // phone: (d.phone ? String(d.phone) : ''),
      //   })
      //   return acc
      // }, {
      //   amount: 0,
      // })
      // app.renderTable = true
      // return totals
      // },
    },
    watch: {
      // search () {
      //   var app = this
      //   app.loading = true
      //   clearTimeout(this.timer)
      //   this.timer = setTimeout(function () {
      //     app.getItems()
      //   }, 1000)
      // },
    },
    created () {
      this.localeText = AG_GRID_LOCALE_EN
    },
    activated () {
      // this.getItems()
    },
    beforeMount () {
      this.bookItems = [
        {
          value: 'total',
          text: this.$t('total'),
        },
        {
          value: 'newspaper',
          text: this.$t('newspaper'),
        },
      ]
    },
    mounted () {
      this.headersMap = this.headers
      this.selectedHeaders = this.headers
      this.fromFinancialYear = this.$store.state.financialYear
      this.toFinancialYear = this.$store.state.financialYear
    },
    methods: {
      edit (item) {
        this.$router.push({ name: 'customerEdit', params: { id: item.id } })
      },
      getItems () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'accountingreport', {
          params: {
            search: app.search,
            page: app.options.page,
            fromFinancialYear: (app.fromFinancialYear ? app.fromFinancialYear.id : null),
            toFinancialYear: (app.toFinancialYear ? app.toFinancialYear.id : null),
            fromDate: app.fromDate,
            toDate: app.toDate,
            report: app.book,
            sortBy: app.sortBy,
            options: app.options,
            totalAccount: app.totalAccount,
          },
        })
          .then(res => {
            res = res.data
            app.data = res
            app.reportName = (app.book === 'total' ? 'totalBook' : 'newspaper')
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      onFilterTextBoxChanged () {
        this.gridApi.setQuickFilter(
          document.getElementById('filter-text-box').value,
        )
      },
      onBtExport () {
        this.gridApi.exportDataAsExcel()
      },
      onGridReady (params) {
        this.gridApi = params.api
        // this.gridColumnApi = params.columnApi
        //
        // const updateData = (data) => {
        //   this.rowData = data
        // }
        //
        // fetch('https://www.ag-grid.com/example-assets/small-olympic-winners.json')
        //   .then((resp) => resp.json())
        //   .then((data) => updateData(data))
      },
    },
  }
</script>
<style scoped>
.ag-theme-alpine {
  --ag-grid-size: 3px !important;
  --ag-list-item-height: 20px !important;
}
.v-badge__badge {
  height: 16px !important;
  min-width: 16px !important;
  padding: 4px 6px !important;
}
.v-data-table > .v-data-table__wrapper .v-data-table__mobile-row {
  height: initial;
  min-height: 32px !important;
}
</style>
